import React from 'react';
import {Route,Link} from 'react-router-dom';
import { ListOfAlfresco } from '../components/listsOfAlfresco/ListOfAlfresco';
import * as ListOfDocuments from '../components/listsOfAlfresco/ListOfDocuments';
import { documentsRegisterRoutes } from '../constants';
import { Content } from './Content';
import { NavLink } from 'reactstrap';
import { Svg } from './Svg';
import i18next from "../i18n";
export function DocumentsRegisterRoutes(props) {
    return (documentsRegisterRoutes.map((item, index) =>
        <Route key={index} exact path={item.path} >
            <Content>
                <div className="content">
                    <ListOfAlfresco type={item.type} typeOfMenu={item.typeOfMenu} saveApi={item.saveApi} parentComponent={ListOfDocuments} title={item.lable}>
                        {props.children}
                    </ListOfAlfresco>
                    {window.location.pathname === "/" && <ul className="cards">
                        <li>
                            <NavLink tag={Link} to="/prices" className="cards-item">
                                <Svg src="/img/icn-big-pricess.svg" />
                                <div>
                                    <h2>{i18next.t("purchasePrices")}</h2>
                                    <span>{i18next.t("currentPurchasePrices")}</span>
                                </div>
                            </NavLink>
                        </li>
                        <li>
                            <NavLink tag={Link} to="/statutoryDocs" className="cards-item">
                                <Svg src="/img/icn-big-folder.svg" />
                                <div>
                                    <h2>{i18next.t("statutoryDocuments")}</h2>
                                    <span>{i18next.t("companyDocument", { company: "" })}</span>
                                </div>
                            </NavLink>
                        </li>
                        <li>
                            <NavLink tag={Link} to="/templates" className="cards-item">
                                <Svg src="/img/icn-big-folder.svg" />
                                <div>
                                    <h2>{i18next.t("templateDocuments")}</h2>
                                    <span>{i18next.t("companyDocument", { company: "" })}</span>
                                </div>
                            </NavLink>
                        </li>
                    </ul>}
                </div>
            </Content>
        </Route>
    ));
}